import {
  DELETEVOUCHERMAPPING_SUCCESS,
  DELETEVOUCHERMAPPING_FAILED,
  RESET_DELETEVOUCHERMAPPING,
  LOADING_DELETEVOUCHERMAPPING,
  NETWORK_ERROR_DELETEVOUCHERMAPPING,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetDeleteVoucherMapping = () => {
  return { type: RESET_DELETEVOUCHERMAPPING };
};

const deleteVoucherMappingList =
  (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_DELETEVOUCHERMAPPING });
    await partnerServices
      .post("deleteVoucherMapping", userData, { headers: { AuthToken: authTokenIs } })
      .then((res) => {
        switch (res.data.status) {
          case "Success":
            dispatch(deleteVoucherMappingsuccess(res.data));
            break;
          default:
            dispatch(deleteVoucherMappingFailed(res.data));
            break;
        }
      })
      .catch((err) => {
        dispatch({
          type: NETWORK_ERROR_DELETEVOUCHERMAPPING,
          payload: err,
        });
      });
  };
function deleteVoucherMappingsuccess(data) {
  return {
    type: DELETEVOUCHERMAPPING_SUCCESS,
    payload: data,
  };
}
function deleteVoucherMappingFailed(data) {
  return {
    type: DELETEVOUCHERMAPPING_FAILED,
    payload: data,
  };
}

export { resetDeleteVoucherMapping, deleteVoucherMappingList };
